var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHiddenEyeWatermark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.87362 14.1316C4.02822 12.8213 2.5679 11.117 1.74272 10.0407C1.51197 9.74366 1.38672 9.37819 1.38672 9.00202C1.38672 8.62585 1.51197 8.26038 1.74272 7.96329C3.23605 6.01387 6.81882 2 11.0017 2C12.8781 2 14.6325 2.80718 16.1328 3.87441",
    stroke: "#00BEC1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1322 6.88828C12.8544 6.60588 12.5235 6.38128 12.1585 6.22742C11.7935 6.07356 11.4016 5.99349 11.0055 5.99183C10.6094 5.99017 10.2169 6.06696 9.85064 6.21775C9.48435 6.36855 9.15155 6.59037 8.87143 6.87043C8.59131 7.15048 8.36941 7.48323 8.21852 7.84948C8.06764 8.21572 7.99077 8.60822 7.99233 9.00432C7.9939 9.40042 8.07388 9.7923 8.22765 10.1573C8.38142 10.5224 8.60595 10.8534 8.88828 11.1312M3 17.0035L19.0035 1M9.0013 15.7072C9.65065 15.9005 10.3242 16.0002 11.0017 16.0033C15.1846 16.0033 18.7674 11.9894 20.2607 10.04C20.4914 9.7426 20.6166 9.37691 20.6164 9.00056C20.6162 8.62422 20.4907 8.25864 20.2597 7.96151C19.7349 7.27685 19.1719 6.62234 18.5734 6.00108",
    stroke: "#00BEC1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiddenEyeWatermark);
export default __webpack_public_path__ + "static/media/hiddenEyeWatermark.b8fff2a5.svg";
export { ForwardRef as ReactComponent };